var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2727 5.45455C11.0677 5.45455 10.0909 6.43138 10.0909 7.63636C10.0909 8.84135 11.0677 9.81818 12.2727 9.81818C13.4777 9.81818 14.4545 8.84135 14.4545 7.63636C14.4545 6.43138 13.4777 5.45455 12.2727 5.45455ZM8.63636 7.63636C8.63636 5.62806 10.2644 4 12.2727 4C14.281 4 15.9091 5.62806 15.9091 7.63636C15.9091 9.64467 14.281 11.2727 12.2727 11.2727C10.2644 11.2727 8.63636 9.64467 8.63636 7.63636ZM5 19.2727C5 15.2561 8.25612 12 12.2727 12C16.2893 12 19.5455 15.2561 19.5455 19.2727C19.5455 19.6744 19.2198 20 18.8182 20C18.4165 20 18.0909 19.6744 18.0909 19.2727C18.0909 16.0594 15.486 13.4545 12.2727 13.4545C9.05944 13.4545 6.45455 16.0594 6.45455 19.2727C6.45455 19.6744 6.12893 20 5.72727 20C5.32561 20 5 19.6744 5 19.2727Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.21c1e40a.svg";
export { ForwardRef as ReactComponent };